export let folderPaneNavigation_noResults = "KkkDLc";
export default {folderPaneNavigation_noResults};